// src/routes.js
import Icon from "@mui/material/Icon";
import About from "pages/About";
import Contact from "pages/Contact";
import Home from "pages/Home"; // in case you want to include it too

export const routes = [
  {
    name: "home",
    icon: <Icon>home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    name: "about",
    icon: <Icon>info</Icon>,
    route: "/about",
    component: <About />,
  },
  {
    name: "contact",
    icon: <Icon>mail</Icon>,
    route: "/contact",
    component: <Contact />,
  },
];
